<div class="img">

<div class="container-for-card">

  <!-- Loading spinner (outside card to avoid white background) -->
  <wl-loading-spinner *ngIf="isLoading" [text]="loadingText"></wl-loading-spinner>

  <mat-card class="login-card" *ngIf="!isLoading && !isOtpDialogOpen && !isErrorDialogOpen">

    <!-- Session expired message (Audit 12026) -->
    <div *ngIf="sessionExpiredMsg" class="bg-fff3cd border-ffc107 border-radius-4 p-10px-14px mb-12px text-856404 font-size-13px">
      {{ sessionExpiredMsg }}
    </div>

    <!-- LOGIN VIEW: Normal login form (only when NOT blocked) -->
    <ng-container *ngIf="!isLoading && loginView === 'login' && !isAccountBlocked && !isOtpDialogOpen">
      <mat-card-title>Login</mat-card-title>
      <mat-card-content>
        <p>Login to view Customers</p>
        <form novalidate [formGroup]="adminForm" (submit)="adminForm.valid && adminLogin(adminForm.value)">
          <div class="row">
            <mat-form-field class="col login-field">
              <input matInput type="tel" placeholder="PF No." formControlName="staffId" maxlength="6" autocomplete="off">
            </mat-form-field>
          </div>
          <div class="row password-row">
            <mat-form-field class="col login-field">
              <input matInput [type]="typeType" placeholder="Password" formControlName="badWord" autocomplete="off">
              <mat-error *ngIf="adminForm.get('badWord').hasError('required')">Password is required</mat-error>
              <mat-error *ngIf="adminForm.get('badWord').hasError('pattern')">Password must be 8-24 characters and include at least one uppercase, lowercase, number, and special character.
                Spaces are not allowed.</mat-error>
            </mat-form-field>
            <div class="text-right z-999">
              <img *ngIf="showPassword" (click)="togglePassword()" class="h-14px opacity-5 mb-neg5px ml-10px pr-15px"
                src="../../../assets/icons/eye.png" />
              <img *ngIf="!showPassword" (click)="togglePassword()" class="h-18px opacity-5 mb-neg5px ml-10px pr-15px"
                src="../../../assets/icons/eye_off.png" />
            </div>
          </div>
          <a routerLink="/reset-password">Forgot Password?</a>
          <p>
            <button mat-raised-button color="primary" [disabled]="!adminForm.valid">Login</button>
          </p>
        </form>

        <!-- Stale account message (Audit 12037) -->
        <!-- <div *ngIf="staleAccountMessage" class="bg-f8d7da border-f5c6cb border-radius-4 p-10px-14px mt-8px text-721c24 font-size-13px">
          {{ staleAccountMessage }}
        </div> -->
      </mat-card-content>
    </ng-container>

    <!-- ACCOUNT LOCKED VIEW: Shown instead of login form when blockeisAccountBlockedd (Audit 12036) -->
    <ng-container *ngIf="!isLoading && loginView === 'login' && isAccountBlocked">
      <div class="locked-header">
        <div class="locked-icon-circle">🔒</div>
        <mat-card-title class="locked-title">Account Locked</mat-card-title>
      </div>
      <mat-card-content>
        <p class="unlock-subtitle">Your account has been locked due to multiple failed login attempts.</p>
        <div class="locked-info-box">
           Use the Unlock Account option below to regain access.
        </div>
        <p>
          <button mat-raised-button color="primary" (click)="submitRequestUnlock()">Unlock Account</button>
        </p>
      </mat-card-content>
       <div class="unlock-back">
          <a (click)="backToLogin()" class="unlock-back-link">&#8592; Back to Login</a>
        </div>
    </ng-container>

    <!-- UNLOCK STEP 1: Enter Staff ID -->
    <ng-container *ngIf="!isLoading && loginView === 'unlock-step1'">
      <div class="unlock-header">
        <!-- Was <mat-icon>lock_open</mat-icon>, a Material Icons ligature. That
             font came from fonts.googleapis.com, which a strict CSP blocks — the
             glyph then rendered as the literal text "lock_open". Inlined as SVG
             so the icon needs no external stylesheet. Uses currentColor, so the
             existing .text-white / font-size-26px styling still applies.
             Path is Material Icons "lock_open" (24px grid). -->
        <div class="unlock-icon">
          <svg class="text-white font-size-26px" width="26" height="26" viewBox="0 0 24 24"
               fill="currentColor" aria-hidden="true" focusable="false">
            <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"/>
          </svg>
        </div>
        <mat-card-title >Unlock Account</mat-card-title>
      </div>
      <mat-card-content>
        <p class="unlock-subtitle">Enter your PF No. to receive an OTP on your registered mobile number.</p>
        <div class="row">
          <mat-form-field class="col unlock-field">
            <input matInput type="tel" placeholder="PF No. / Staff ID" [(ngModel)]="unlockStaffId" maxlength="8" autocomplete="off">
          </mat-form-field>
        </div>
        <div *ngIf="unlockError" class="unlock-error">{{ unlockError }}</div>
        <p>
          <button mat-raised-button color="primary" [disabled]="(!unlockStaffId )|| ((unlockStaffId.length < 4) || (unlockStaffId.length >= 8 ))" (click)="submitRequestUnlock()">Send OTP</button>
        </p>
        <div class="unlock-back">
          <a (click)="backToLogin()" class="unlock-back-link">&#8592; Back to Login</a>
        </div>
      </mat-card-content>
    </ng-container>

    <!-- UNLOCK STEP 2: Enter OTP -->
    <ng-container *ngIf="!isLoading && loginView === 'unlock-step2'">
      <div class="unlock-header">
        <div class="unlock-icon">🔓</div>
        <mat-card-title>Enter OTP</mat-card-title>
      </div>
      <mat-card-content>
        <p class="unlock-subtitle"><strong>{{ maskedContact }}</strong></p>
        <!-- <div class="row">
          <mat-form-field class="col unlock-field">
            <input matInput type="tel" placeholder="Enter OTP" [(ngModel)]="unlockOtp" maxlength="6" autocomplete="off">
          </mat-form-field>
        </div> -->

        <div class="otp-boxes unlock-otp-boxes">

            <input #u1
                  class="otp-box"
                  maxlength="1"
                  [(ngModel)]="unlockOtpDigits[0]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onUnlockOtpInput(0, $event, u2)"
                  (keydown)="onUnlockOtpKeydown(0, $event, null)">

            <input #u2
                  class="otp-box"
                  maxlength="1"
                  [(ngModel)]="unlockOtpDigits[1]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onUnlockOtpInput(1, $event, u3)"
                  (keydown)="onUnlockOtpKeydown(1, $event, u1)">

            <input #u3
                  class="otp-box"
                  maxlength="1"
                  [(ngModel)]="unlockOtpDigits[2]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onUnlockOtpInput(2, $event, u4)"
                  (keydown)="onUnlockOtpKeydown(2, $event, u2)">

            <input #u4
                  class="otp-box"
                  maxlength="1"
                  [(ngModel)]="unlockOtpDigits[3]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onUnlockOtpInput(3, $event, u5)"
                  (keydown)="onUnlockOtpKeydown(3, $event, u3)">

            <input #u5
                  class="otp-box"
                  maxlength="1"
                  [(ngModel)]="unlockOtpDigits[4]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onUnlockOtpInput(4, $event, u6)"
                  (keydown)="onUnlockOtpKeydown(4, $event, u4)">

            <input #u6
                  class="otp-box"
                  maxlength="1"
                  [(ngModel)]="unlockOtpDigits[5]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onUnlockOtpInput(5, $event, null)"
                  (keydown)="onUnlockOtpKeydown(5, $event, u5)">

          </div>

        <div *ngIf="unlockError" class="unlock-error">{{ unlockError }}</div>
        <p>
          <button mat-raised-button color="primary" [disabled]="!allUnlockOtpDigitsFilled || unlockOtpBlocked" (click)="submitVerifyUnlockOtp()">Verify OTP</button>
        </p>
        <!-- <div class="unlock-back">
          <a (click)="loginView = 'unlock-step1'" class="unlock-back-link">&#8635; Resend OTP</a>
        </div> -->
        <div class="unlock-back flex justify-evenly align-center gap-10px">
          <a (click)="backToLogin()" class="unlock-back-link">&#8592; Back to Login</a>
 
          <a
            (click)="resendUnlockOtp()"
            class="unlock-back-link"
            [class.disabled-link]="unlockResendDisabled">

            &#8635; Resend OTP

            <span *ngIf="unlockResendDisabled">
              ({{ unlockTimer }})
            </span>

          </a>
           
        </div>


      </mat-card-content>
    </ng-container>

  </mat-card>
</div>

</div>

